export default __webpack_public_path__ + "static/media/default-user.b24c669d.svg";